import { TwoFactorComponent } from './two-factor/two-factor.component';
import { CommonModule } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MessageService } from 'primeng/api';
import { LoginRoutingModule } from './login-routing.module';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LoginLayoutComponent } from './login-layout.component';
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { LoginConfig } from './login.config';
import { LoginService } from './login.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CapturumFormFieldModule } from '@capturum/ui/form-field';
import { CapturumInputModule } from '@capturum/ui/input';
import { CapturumPasswordModule } from '@capturum/ui/password';
import { CapturumButtonModule } from '@capturum/ui/button';
import { CapturumToggleSwitchModule } from '@capturum/ui/input-switch';
import { CssUrlPipe } from './pipes/css-url.pipe';
import { ActivationComponent } from './activation/activation.component';
import { CapturumActivationService } from './services/activation.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CapturumInputCodeModule } from '@capturum/ui/input-code';

export function MyHttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    LoginLayoutComponent,
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    CssUrlPipe,
    TwoFactorComponent,
    ActivationComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LoginRoutingModule,
    CapturumButtonModule,
    CapturumInputModule,
    CapturumPasswordModule,
    CapturumFormFieldModule,
    CapturumToggleSwitchModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: MyHttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    BrowserAnimationsModule,
    CapturumInputCodeModule,
  ],
  exports: [],
  providers: [MessageService, provideHttpClient(withInterceptorsFromDi())],
})
export class LoginModule {
  public static forRoot(loginConfig: Partial<LoginConfig>): ModuleWithProviders<LoginModule> {
    const defaultConfig = new LoginConfig();
    const config = {
      ...defaultConfig,
      ...loginConfig,
    };

    return {
      ngModule: LoginModule,
      providers: [
        {
          provide: LoginConfig,
          useValue: config,
        },
        {
          provide: LoginService,
          useClass: loginConfig.loginService || LoginService,
        },
        {
          provide: CapturumActivationService,
          useClass: loginConfig.activationService || CapturumActivationService,
        },
      ],
    };
  }
}
